import Forms from './Forms'
import { BlockWrapper } from 'common/widgets'


export default function FormsBlock(props) {
  return (
    <BlockWrapper>
      <Forms {...props} />
    </BlockWrapper>
  )
}
